<template>
    <section v-if="hasPermissions(['QC-Inspection Read', 'QC-Inspection Write'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            {{ title_page }}
        </h1>
        <div class="view__description">
            <p class="view__description__text">
                This is a list of inspections. Filter the list by selecting All, Complete, or Incomplete. To create a new inspection, click "Add instant inspection" or "New Multiple Room Inspection".
            </p>
        </div>

        <div class="bar-container-inspections">
            <div class="bar-container-inspections__search-bar">
                <div class="input-field my-0" >
                    <i class="material-icons prefix iconInput">search</i>
                    <input type="text" class="validate inputSearch" placeholder="Search" v-on:input="debounceInput($event.target.value)">
                </div>
            </div>
            <div class="bar-container-inspections__options">
                <button class="modal__buttons__item w-auto px-3" v-html="'Mass Delete'" :class="!selectedInstant() ? '' : 'disabled button__disabled'" :disabled="selectedInstant()" @click="massive_modal_delete()"/>
                <button class="modal__buttons__item w-auto px-3" v-html="'Copy Inspections Sent'" @click="showCopyInspectionsSentModal()"/>
            </div>
            <div class="bar-container-inspections__cta" v-if="hasPermissions(['QC-Inspection Write'])">
                <span class="text-md-right mr-3" v-for="(val, i) in add_btn" :key="i">
                    <a @click="val.event !== undefined && val.event ? goToView(val.ref_view) : form_modal(val.tag_name)" class="d-inline-md-block">
                        {{ val.name }}
                        <i class="prefix ml-1">
                            <img src="/assets/img/svg/add.svg" alt="date" style="width: 15px">
                        </i>
                    </a>
                </span>
            </div>
        </div>

        <div class="row mb-3 no-gutters" v-if="hasPermissions(['QC-Inspection Read'])">
            <div class="col-12">
                <LocalFormFilter 
                    :array_options="array_options"
                    :form_data_filter="form_data_filter"
                    :show_view_inspections="true"
                />
                
                <div class="mt-3" style="margin-top:30px;">
                    <InspectionView
                        :table_headers="table_headers"
                        :form_data_filter="form_data_filter"
                        @modalUpdate="modal_update_inspection($event)"
                        @modalDeletion="modal_deletion($event)"
                        ref="instant_inspection"
                        :search="search"
                    />
                    
                </div>
            </div>
        </div>

        <DeletionModal
            :single_object="single_object" 
            :global_index="global_index" 
            @objectDeletion="object_deletion_child(mutable_endpoint, $event)"
        />

        <FormModal2 
            :title="'New Multiple Room Inspection'"
            :breadcrumb="breadcrumb"
            :rest_api="rest_api"
            :notyf="notyf"
            :array_options="array_options_template"
            :save_view="true"
            @unshiftObject="unshift_object(template_inspections, $event); redirect_to('/qc-inspections/', $event);"
            @saveView="save_and_view($event)"
        />

        <FormModal
            :title="'New Instant Inspection'"
            :breadcrumb="breadcrumb"
            :rest_api="rest_api"
            :global_api_rooms_pag="global_api_rooms_pag"
            :notyf="notyf"
            :array_options="array_options"
            :save_view="true"
            @unshiftObject="unshift_object(instant_inspections, $event); redirect_to('/qc-inspections/', $event);"
            @saveView="save_and_view($event)"
            ref="form_modal_instant"
        />

        <UpdateModal
            :title="'Instant Inspection Update'"
            :breadcrumb="breadcrumb"
            :rest_api="rest_api"
            :global_api_rooms_pag="global_api_rooms_pag"
            :notyf="notyf"
            :single_object="single_object"
            :global_index="global_index"
            :array_options="array_options"
            @spliceObject="splice_object(instant_inspections, $event)"
            ref="update_modal_instant"
        />

        <UpdateModalTemplate 
            :title="'Multiple Room Inspection'"
            :breadcrumb="breadcrumb"
            :rest_api="rest_api"
            :notyf="notyf"
            :single_object="single_object"
            :global_index="global_index"
            :array_options="array_options_template"
            @spliceObject="splice_object(template_inspections, $event)"
            ref="update_modal_template"
        />

        <CopyInspectionSentModal 
            :breadcrumb="breadcrumb"
            :data="data"
            :rest_api="rest_api"
        />
        <WaitingModal/>

        <HelperModal :helps="helps"/>

        <DeletionMassiveModal
            @objectDeletion="massive_local_emition($event)"
        />
    </section>
    <div v-else>
        <UnauthorizedComponent :breadcrumb="breadcrumb"/>
    </div>
</template>

<script>

import Breadcrumb               from    '@/components/BreadcrumbComponent/Breadcrumb'
import InspectionView    from    './InspectionView'
import CopyInspectionSentModal   from    './CopyInspectionSentModal'
// import AssignmentInspectionView from    './AssignmentInspectionView'
import HelperModal              from    '@/components/HelperModal'
import WaitingModal             from    '@/components/WaitingModal'
import Resources                from    './resources'
import FormModal                from    './FormModal'
import FormModal2               from    './FormModal2'
import FormResources            from './form_resources'
// import FormModal3               from    './FormModal3'
import UpdateModal              from    './UpdateModal'
import UpdateModalTemplate      from    './UpdateModalTemplate'
import DeletionModal            from    '@/components/DeletionModal'
import DeletionMassiveModal     from    '@/components/DeletionMassiveModal'
import UnauthorizedComponent from   '@/components/UnauthorizedComponent'
import _ from 'lodash'

import 'vuetify/dist/vuetify.min.css'

import { Notyf }            from    'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
import LocalFormFilter from './LocalFormFilter.vue'
const notyf = new Notyf({
    duration: 8000,
});

export default {
    
    name: 'Inspection',

    components:{
    Breadcrumb,
    WaitingModal,
    DeletionModal,
    FormModal,
    FormModal2,
    // FormModal3,
    UpdateModal,
    UpdateModalTemplate,
    InspectionView,
    DeletionMassiveModal,
    UnauthorizedComponent,
    LocalFormFilter,
    CopyInspectionSentModal,
    HelperModal
},

    data() {
        return {
            notyf,
            user:             this.get_user(),
            title_page:       'Inspections',
            rest_api:         'inspections',
            rest_api_backup:  [ ...Resources.rest_api ],
            global_api_rooms_pag: 'global_rooms_pagination',
            mutable_endpoint: '',
            table_headers:    Resources.table_headers,
            table_headers2:   Resources.table_headers2,
            table_headers3:   Resources.table_headers3,
            breadcrumb:       Resources.breadcrumb,
            add_btn:          Resources.add_btn,
            tabs:             Resources.tabs,
            single_select:    false,
            table_selection:  [],
            search:           '',
            update_mode:      false,
            global_index:     0,
            global_index_template: 0,
            global_status: '',
            single_object: {
                id: '',
                associate_id: '',
                employee_associate_id: '',
                inspection_template_id: '',
                room_id: '',
                associate: '',
                employee_associate: '',
                inspection_template: '',
                room: '',
                title: '',
                date: '',
                inspection_report: '',
                checked: '',
                status: '',
                manager_comment: '',
                employee_firm: '',
            },

            single_object_template: {
                id: '',
                associate_id: '',
                employee_associate_id: '',
                inspection_template_id: '',
                room_type_id: '',

                associate: '',
                employee_associate: '',
                inspection_template: '',
                room_type: '',

                title: '',
                date: '',
                room_count: '',
                random_room: '',
                inspection_report: '',
                room_id: [],
                rooms: [],
                rooms_counter: '',
                checked: '',
                status: '',
                manager_comment: '',
                employee_firm: '',
            },

            instant_inspections:    [],
            template_inspections:   [],
            assignment_inspections: [],
            array_options: {
                room_id:    [],
                associate_id: [],
                room_type_id: [],
                inspection_template_id: [],
                building_id: [],
                level_id: [],
                area_id: [],
            },
            array_options_template: {
                room_id:    [],
                associate_id: [],
                room_type_id: [],
                inspection_template_id: [],
                building_id: [],
                level_id: [],
                area_id: [],
            },
            select_instant_inspections_ids:    [],
            select_template_inspections_ids:   [],
            select_assignment_inspections_ids: [],
            save_view:                         false,
            form_data_filter: FormResources.form_data_filter,
            data: [],
            helps:                  Resources.helps
        }
    },

    methods: {
        splice_object()
        {
            this.form_data_filter['module_name'] = null
        },

        unshift_object()
        {
            this.form_data_filter['module_name'] = null
        },

        modal_update_inspection(index)
        {
            this.global_index = index
            this.single_object = { ...this.$refs.instant_inspection.instant_inspections[index], rooms: [], room_ids: [], room_id: '' }
            if(this.single_object.inspection_type_id == 1)
            {
                this.$refs.update_modal_instant.setupForm({...this.$refs.instant_inspection.instant_inspections[index]})
                window.$('#static-update').modal('show')
            }
            else
            {
                window.$('#static-update-template').modal('show')
                this.$refs.update_modal_template.setupForm(this.single_object)
            }
        },

        modal_update_template(index)
        {
            this.global_index_template = index
            this.single_object_template = { ...this.$refs.template_inspection.template_inspections[index] }
            window.$('#static-update-template').modal('show')
        },

        goToView(ref_view)
        {
            window.location.href = `/${ref_view}`
        },

        form_modal(tag_name)
        {
            if(!this.user.has_facility){
                notyf.error('There is not exists a facility yet')
                return false
            }

            this.$refs.form_modal_instant.setupForm()
            this.update_mode = false
            window.$(`#${tag_name}`).modal('show')
        },

        modal_deletion(object)
        {
            this.global_index     = object.index
            this.single_object    = object.value
            this.mutable_endpoint = object.endpoint
            window.$('#static-deletion').modal('show')
        },

        fill_data(data)
        {
            this.array_options = {
                associate_id:             data.supervisors,
                employee_id:              data.employees,
                inspection_template_id:   data.inspection_templates,
                daily_assignment_id:      [],
                room_id:                  [],
                room_type_id:             [],
                inspection_type_id:       data.inspection_types,
                shift:                    Resources.shift_options,
                template_id:              data.templates,
                building_id:              data.buildings,
                level_id:                 [],
                area_id:                  []
            }

            this.array_options_template = {
                associate_id:             data.supervisors,
                employee_id:              data.employees,
                inspection_template_id:   data.inspection_templates,
                daily_assignment_id:      [],
                room_id:                  [],
                room_type_id:             [],
                inspection_type_id:       data.inspection_types,
                shift:                    Resources.shift_options,
                template_id:              data.templates,
                building_id:              data.buildings,
                level_id:                 [],
                area_id:                  []
            }
        },

        trashing(index)
        {
            this[this.mutable_endpoint].splice(index, 1)
        },

        massive_modal_delete()
        {
            if(this.$refs.instant_inspection) 
            {
                this.select_instant_inspections_ids = this.$refs.instant_inspection.instant_inspections.filter(item => item.checked).map(item => item.id)
            }
            if(this.$refs.template_inspection)
            {
                this.select_template_inspections_ids = this.$refs.template_inspection.template_inspections.filter(item => item.checked).map(item => item.id)
            }
            
            if(this.select_instant_inspections_ids.length || this.select_template_inspections_ids.length)
            {
                window.$('#static-deletion-massive').modal('show')
            }
        },

        async massive_local_emition()
        {
            if(this.select_instant_inspections_ids.length)
            {
                let json_request = {
                    ids:         this.select_instant_inspections_ids,
                }

                let sendingMassive = await this.massive_delete(json_request)

                if(sendingMassive)
                {
                    this.select_instant_inspections_ids = []
                }
            }

            this.form_data_filter['module_name'] = null
            
        },

        async showCopyInspectionsSentModal()
        {
            this.loader(true)

            const response = await this.get(`${this.rest_api}/get/copy_inspections_sent`)

            if(response.status)
            {
                this.data = response.data.data
                console.log(this.data)
                window.$('#copy-inspection-sent-modal').modal('show')
            }
            else
            {
                this.error_handling(response)
            }

            this.loader()


        },

        save_and_view(event)
        {
            this.save_view = event
        },

        redirect_to(url, new_object)
        {
            if(this.save_view)
            {
                window.location.href = `${url}${new_object.id}`
            }
        },

        selectedInstant()
        {
            const send = this.$refs.instant_inspection && this.$refs.instant_inspection.instant_inspections.filter(item => item.checked).length ? false : true
            return send
        },

        selectedTemplate()
        {
            const send = this.$refs.template_inspection && this.$refs.template_inspection.template_inspections.filter(item => item.checked).length ? false : true
            return send
        },

        debounceInput:  _.debounce(function (e)  {
            this.search = e
        },800),

    },

    async mounted()
    {
        if(this.hasPermissions(['QC-Inspection Read', 'QC-Inspection Write']))
        {
            await this.api_request()

            this.form_data_filter['page'] = 1
            this.form_data_filter['module_name'] = 'inspections'
        }
    },

    computed:
    {
        
    }
}
</script>
